import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,{class:_vm.isSelected ? 'white--text' : undefined,attrs:{"color":_vm.isSelected ? 'primary' : undefined},on:{"click":function($event){return _vm.$emit('selected', _vm.scope.identifier)}}},[_vm._v("\n  "+_vm._s(_vm.scope.title_i18n)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }